import api from './api';

interface IVacancyGroupAPIPayload {
  id: string;
  title: string;
  description: string;
  division: string;
  order: number;
}

async function editVacancyGroupAPI({
  id,
  title,
  description,
  division,
  order,
}: IVacancyGroupAPIPayload) {
  const response = await api.patch(`group/${id}/`, {
    title, description, division, order,
  });
  return response?.data;
}

export default editVacancyGroupAPI;
